module.exports = __webpack_public_path__ + "static/img/suo.6c3c059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suo.png
// module id = stQ6
// module chunks = 1